// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Plus Jakarta Sans', 'Plus Jakarta Sans Fallback'","fontStyle":"normal"},"className":"__className_5416d4","variable":"__variable_5416d4"};